import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useNavigate, Navigate } from "react-router-dom";

import "primereact/resources/themes/tailwind-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./output.css";
import "./App.css";

import GlobalContext     from "../isp._comun/iu/contexto/GlobalContext";
import PantallaPrincipal from "../isp._iu.start.principal/componentes/PantallaPrincipal";
import PantallaLogin     from "../isp.iu.idyacceso/componentes/PantallaLogin";
import * as TipoDeError from '../isp._comun/services/Errores'
// import * as Evento from "./comun/Eventos";
/** @returns {React.element}  PresentadorAppEnrutado */
/** @returns {React.element}  PresentadorApp*/

function App() {
    return (
        <BrowserRouter>
            <React.StrictMode>
                <RutasDelApp />
            </React.StrictMode>
        </BrowserRouter>
    );
}

/** @returns {React.element}  PresentadorApp*/
function RutasDelApp() {
    const [usuario, setUsuario] = useState(null);
    //useNavigate solo puede usarse en un contexto dentro de un BrowserRouter
    const navigate = useNavigate();

    if (usuario === null) {
        const cargarPantallaPrincipal = (usuario) => {
            setUsuario(usuario);
            navigate("/", { replace: true });
        };

        /* const presentadorLogueo = (
            <PresentadorLogueo
                cargarPantallaPrincipal={cargarPantallaPrincipal}
            />
        ); */
        const pantallaLogin = (
            <GlobalContext.Provider value={{cargarPantallaPrincipal}}>
                <PantallaLogin
                    cargarPantallaPrincipal={cargarPantallaPrincipal}
                />
            </GlobalContext.Provider>
        );
        return RutasALaPantallaLogin(pantallaLogin);
        // return RutasAlPresentadorLogueo(presentadorLogueo);
    
    } else {
        const cargarPantallaLogin = () => {
            setUsuario(null);
            navigate("/login", { replace: true });
        };

        const handleErroresExtraEnApp = (error)=>{      
            if (error instanceof TipoDeError.ErrorEnIdSesion) {
                cargarPantallaLogin();
                
            }
            return;
        }

        const contextoGlobal = (
            // <GlobalContext.Provider value={{ cargarPantallaLogin, handleErroresExtraEnApp, usuario }}>
            <GlobalContext.Provider value={{ cargarPantallaLogin, handleErroresExtraEnApp, usuario }}>
                <PantallaPrincipal />
            </GlobalContext.Provider>
        );
        return RutasALaPantallaPrincipal(contextoGlobal);
    }
}

function RutasALaPantallaLogin(pantallaLogin) {
    return (
        <Routes>
            <Route path="/login" element={pantallaLogin} />
            <Route path="*" element={<Navigate to="login" />} />
        </Routes>
    );
}

function RutasALaPantallaPrincipal(pantallaPrincipal) {
    return (
        <Routes>
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/" element={pantallaPrincipal} />
        </Routes>
    );
}

export default App;
